import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { apiClient } from '~admin/client';
import { SeatConfigurationData } from '~admin/model/seat-configuration-data';
import { mapSeatConfigurationDataList } from '~admin/model/seat-configuration-data.mapper';
import { SeatConfigurationResponse } from '~client/model/admin/seat-configuration-response';
import { OneArgTask, rxTask } from '~common/helper/mobx-tasks';

export type GetSeatConfigurationsTask = OneArgTask<number, SeatConfigurationData[]>;

const performGetSeatConfigurations = (
  locationProfileId: number,
): Observable<SeatConfigurationResponse[]> =>
  apiClient.locationProfileAdminController.getListOfSeatConfigurations$(locationProfileId);

export const getSeatConfigurationsTaskFactory = (): GetSeatConfigurationsTask =>
  rxTask<number, SeatConfigurationData[]>((locationProfileId: number) =>
    performGetSeatConfigurations(locationProfileId).pipe(map(mapSeatConfigurationDataList)),
  );



// WEBPACK FOOTER //
// ./interactor/location/perform-get-seat-configurations.ts